<script setup lang="ts">
  const { loggedIn } = useUserSession()

  // Redirect to todos if already logged in
  if (loggedIn.value) {
    navigateTo('/todos')
  }
</script>

<template>
  <div class="flex flex-col gap-4">
    <p class="font-medium">Welcome to Atidone.</p>
    <p>
      A
      <a
        href="https://nuxt.com"
        target="_blank"
        class="text-(--ui-primary)"
        rel="noopener"
        >Nuxt</a
      >
      demo hosted on
      <a
        href="https://pages.cloudflare.com"
        target="_blank"
        rel="noopener"
        class="text-(--ui-primary)"
        >Cloudflare Pages</a
      >
      with server-side rendering on the edge and using
      <NuxtLink
        href="https://developers.cloudflare.com/d1/"
        target="_blank"
        rel="noopener"
        class="text-(--ui-primary)"
      >
        Cloudflare D1 database </NuxtLink
      >.
    </p>
    <p>
      It is made using
      <a href="https://hub.nuxt.com" class="text-(--ui-primary)">NuxtHub</a> for
      a zero-config development & deployment experience on Cloudflare.
    </p>
    <USeparator />

    <div v-if="!loggedIn" class="flex flex-col gap-3">
      <p class="font-medium">Get started:</p>
      <div class="flex gap-2">
        <UButton
          to="/login"
          icon="i-lucide-log-in"
          label="Login"
          color="primary"
        />
        <UButton
          to="/register"
          icon="i-lucide-user-plus"
          label="Sign Up"
          color="neutral"
          variant="outline"
        />
      </div>
      <UDivider label="or" />
      <UButton
        to="/api/auth/github"
        icon="i-simple-icons-github"
        label="Continue with GitHub"
        color="neutral"
        variant="outline"
        external
      />
    </div>

    <USeparator />
    <p class="text-sm text-(--ui-text-muted) italic">
      Your account information is securely stored and encrypted.<br />
      We only store the todos you create linked with your account.
    </p>
  </div>
</template>
